const options = {
  5: "bg-blue-900/5",
  10: "bg-blue-900/10",
  25: "bg-blue-900/25",
  50: "bg-blue-900/50",
  75: "bg-blue-900/75",
  90: "bg-blue-900/90",
  100: "bg-blue-900",
};

const from = {
  5: "from-blue-900/5",
  10: "from-blue-900/10",
  25: "from-blue-900/25",
  50: "from-blue-900/50",
  75: "from-blue-900/75",
  90: "from-blue-900/90",
  100: "from-blue-900",
};

export default function getBackgroundBlue900(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
